export default {
  // general
  title: "Title",

  // actions
  create_new_brand_story: "Create new brand story",

  // search
  search_brand_stories: "Search Brand stories",
  no_brand_stories_found: "No brand stories found.",

  // messages
  brand_story_deleted_successfully: "Brand story deleted successfully"
};
